"use strict";

import Vue from 'vue';

Vue.filter('number', function(value, decimalParam) {
  var accounting = require("accounting");
  var decimal = typeof(decimalParam) !== 'undefined' ? decimalParam : 2;
  // decimal = value == 0 ? 0 : decimal;
  // if(value == 0){
  //   decimal = 0
  // }else if(value == '-'){
  //   decimal = 0
  // }else{
  //   decimal = decimal
  // }
  if(window.account.showDecimals == false){
    //value = Math.floor(value)
  }
  var factor = Math.pow(10, decimal);
  var tempNumber = value * factor;
  var roundedTempNumber = 0;
  //if (isDown) { // roundDown
    tempNumber = -tempNumber;
    roundedTempNumber = Math.round(tempNumber) * -1;
  //} else { // roundUp
    //roundedTempNumber = Math.round(tempNumber);
  //}
  value=roundedTempNumber/factor
  return accounting.formatNumber(value, decimal, ',');
  //return accounting.formatNumber(Math.floor(value*100)/100, decimal, ',');
})

Vue.filter('odd', function(value, decimalParam) {
  return parseFloat(value).toFixed(2);
})

Vue.filter('roundUpNumber', function(value, isRoundUp) {
  if(value == '-') {
    return value
  }

  var accounting = require("accounting");
  var decimal = 0;

  isRoundUp = typeof(isRoundUp) === 'undefined' ? true : isRoundUp;

  value = isRoundUp ? Math.ceil(parseFloat(value)) : Math.floor(parseFloat(value))

  return accounting.formatNumber(value, decimal, ',');
})

Vue.filter('ccl', function(value, decimalParam) {
  var accounting = require("accounting");
  if(value){
    var decimal = typeof(decimalParam) !== 'undefined' ? decimalParam : 2;
    if(window.account.showDecimals){
      if(typeof(value) === "string"){
        value = parseFloat(value.split(',').join(''))
      }
    }else{
      if(typeof(value) == "string"){
        value = Math.floor(parseFloat(value.split(',').join('')))
      }else if(typeof(value) === "number"){
        value = Math.floor(value)
      }
    }
    decimal = value == 0 ? 0 : decimal;
    if(value == '-') {
      return value
    }
  }
  return accounting.formatNumber(Math.floor((value*100).toFixed(2))/100, decimal, ',');
})


// WEBPACK FOOTER //
// ./resources/score/vue/filters/vue-filter-number.js